"use client";
import { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { adobeData, generateAdobeDataRaceNo, theme } from "@/app/utils/Common";
import {BannerOnclick,GetBanners} from "@/app/utils/class/cms/banner"

import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/css/pagination';
import '../../style/bottomBanner.scss';
import { useMyContext } from "@/app/utils/MyContext";

const BottomBanner: React.FC = () => {
  const { state: lang } = useLanguage();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  const [bottomCarnivalBanner, setBottomCarnivalBanner] = useState<any>(null);

  useEffect(() => {
    GetBanners(lang.langCode,"Bottom",(enableBannerList:BannerData[])=>{
      const banner = enableBannerList;
      setBottomCarnivalBanner(banner);
   }, isMobile)

  }, []);

  if(!bottomCarnivalBanner)
    return (<></>)

  return (
    <BannerBottomSwiper isMobile={isMobile} bannerArr={bottomCarnivalBanner} limit={10}/>    
  );
};

const BannerBottomSwiper = (props: any) => {
  const {state:lang} = useLanguage();
  const {state: myContextState} = useMyContext();
  const {isMobile,bannerArr,limit} = props
  const pagination={
    el: '.bannerPagination_bottom',
    clickable:true,
    renderBullet: (index: number, className: string) => {
      return `<span class="${className}"></span>`;
    }
  }
  const loop=bannerArr.length>1?true:false
  const isOnePicture=!loop

  const onClickBanner = (banner: BannerData) => {                        
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      internalAd: "SPLDSP_racing/simulcast_BottomBanner",
      eventId: "racing/simulcast_ClickBanner_AnyPage_BottomBanner",
      raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf())
    });
    BannerOnclick(banner, "BottomBanner");
  };

  return (
    <div id="race_bottom_banner_container" style={{ marginTop: "12px" }}>
      {
        bannerArr?.length ?
          <Swiper
            slidesPerView={1}
            centeredSlides={true}
            spaceBetween={0}
            modules={[Pagination, Navigation, Autoplay]}
            pagination={isMobile ? pagination : false}
            navigation={isMobile ? false : true}
            loop={loop}
            className="bottombannerRoot"
          >
            {
              bannerArr.map((banner: BannerData, index: number) => {
                return (
                  index < limit &&
                  <SwiperSlide key={index}>
                    <img
                      src={isMobile ? banner?.imageUrl_Mobile?.value || banner.imageUrl.value: banner.imageUrl.value}
                      className={banner.redirectionLink.value && "clickable"}
                      onClick={() => onClickBanner(banner)} />
                  </SwiperSlide>
                )
              })
            }
          </Swiper>
          : <></>
      }
      {isMobile && !isOnePicture && <div className="bannerPagination_bottom"></div>}
    </div>
  );
}


export default BottomBanner;
